import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";

// Stable per-session hue so a session keeps its colour while panning.
function sessionHue(session) {
  let hash = 0;
  const s = String(session || "");
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) | 0;
  }
  return ((hash % 360) + 360) % 360;
}

const styleCache = {};

export function getMomaTracesStyleNormal(feature) {
  const session = feature.get("session");
  if (!styleCache[session]) {
    styleCache[session] = new Style({
      stroke: new Stroke({
        color: `hsla(${sessionHue(session)}, 85%, 40%, 0.75)`,
        width: 2.5,
      }),
    });
  }
  return styleCache[session];
}

export function getMomaTracesStyleHover(feature) {
  return new Style({
    stroke: new Stroke({
      color: `hsl(${sessionHue(feature.get("session"))}, 95%, 30%)`,
      width: 5,
    }),
  });
}
